import { Box, Button, TextField, SelectChangeEvent, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FilterList, FilterListOff } from "@mui/icons-material";
import { useEffect, useState } from "react";

import { CustomerFiltersStyle } from "./style";

interface IDefaultValues {
    activeTier: "trial" | "noun" | "normal" | "freeCountries" | null;
    search: string;
    active: number | null;
    emailVerified: number | null;
    // hasSubscription: number | null;
}

export const defaultValues: IDefaultValues = {
    activeTier: null,
    search: "",
    active: null,
    emailVerified: null,
    // hasSubscription: null,
};

const localFilters = localStorage.getItem("CustomerFilters");
const prevFilter = localFilters ? JSON.parse(localFilters) : "";

// eslint-disable-next-line no-unused-vars
export default function CustomerFilters({ onApply }: { onApply: (data: typeof defaultValues) => void }) {
    const [fields, setFields] = useState<IDefaultValues>(prevFilter || defaultValues);
    const [filterActivated, setFilterActivated] = useState<boolean>(false);

    const handleApply = () => onApply && onApply(fields);
    const toggleFilters = () => setFilterActivated((prev) => !prev);
    const handleReset = () => {
        setFields(defaultValues);
        localStorage.setItem("CustomerFilters", JSON.stringify(defaultValues));
        if (onApply) onApply(defaultValues);
    };

    useEffect(() => {
        if (fields.search === "") {
            onApply(fields);
        }
    }, [fields, onApply]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        const name = event.target.name;
        const value = event.target.value;

        setFields((prev) => {
            const filterData = {
                ...prev,
                [name]: value,
            };

            localStorage.setItem("CustomerFilters", JSON.stringify(filterData));

            return filterData;
        });
    };

    return (
        <CustomerFiltersStyle>
            <Box className="filter-wrapper">
                {filterActivated && (
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item lg={3} md={4} xs={12}>
                            <TextField
                                fullWidth
                                className="input field "
                                label="Search"
                                name="search"
                                placeholder="Enter some text"
                                size="small"
                                value={fields.search}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="select-label">Status</InputLabel>
                                <Select
                                    id="select"
                                    label="status"
                                    labelId="select-label"
                                    name="active"
                                    value={String(fields.active)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value={1 as any}>Active </MenuItem>
                                    <MenuItem value={0 as any}>Deactivate</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="email-label">Email Confirm</InputLabel>
                                <Select
                                    id="emailVerified"
                                    label="Email Confirmed"
                                    labelId="email-label"
                                    name="emailVerified"
                                    value={String(fields.emailVerified)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}> All</MenuItem>
                                    <MenuItem value={1 as any}> Confirmed </MenuItem>
                                    <MenuItem value={0 as any}> Not Confirmed </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="email-label">Has Subscription</InputLabel>
                                <Select
                                    id="hasSubscription"
                                    label="Has Subscription"
                                    labelId="hasSubscription-label"
                                    name="hasSubscription"
                                    value={String(fields.hasSubscription)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}> All</MenuItem>
                                    <MenuItem value={1 as any}> Subscribed </MenuItem>
                                    <MenuItem value={0 as any}> Not Subscribed </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid> */}
                        <Grid item lg={2} md={4} xs={12}>
                            <FormControl fullWidth className="select field" size="small">
                                <InputLabel id="email-label">Subscription Type</InputLabel>
                                <Select
                                    id="activeTier"
                                    label="Free Usage Type"
                                    labelId="activeTier-label"
                                    name="activeTier"
                                    value={String(fields.activeTier)}
                                    onChange={handleChange}
                                >
                                    <MenuItem value={null as any}>All</MenuItem>
                                    <MenuItem value={"noun" as any}>No Subscription</MenuItem>
                                    <MenuItem value={"trial" as any}>Trial</MenuItem>
                                    <MenuItem value={"normal" as any}>Subscription</MenuItem>
                                    <MenuItem value={"freeCountries" as any}>Free Countries</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg={3} xs={12}>
                            <Box className="actions">
                                <Button className="action-btn" variant="contained" onClick={handleApply}>
                                    Apply
                                </Button>
                                <Button className="action-btn" variant="contained" onClick={handleReset}>
                                    reset
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Box>
            <Button
                className="filter-btn"
                startIcon={filterActivated ? <FilterListOff /> : <FilterList />}
                variant="contained"
                onClick={toggleFilters}
            >
                Filters
            </Button>
        </CustomerFiltersStyle>
    );
}
